import { Component, Input, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Customers } from '../../../account-info-header/models/AccountInfoApiResponse';
import { EAuthInfo } from '../../models/EAuthInfo';
import { clientAuthDetailsLabel, Constants } from '../../utilities/Constants';

@Component({
  standalone: false,
  selector: 'mm-client-auth-details-section',
  templateUrl: './client-auth-details-section.component.html',
  styleUrls: ['./client-auth-details-section.component.scss']
})
export class ClientAuthDetailsSectionComponent implements OnInit {
  @Input() eAuthCustomers$: Observable<Customers[]>;
  @Input() eAuthInfo$: Observable<EAuthInfo>;
  @Input() useCondensedLayout: boolean;
  readonly labels = clientAuthDetailsLabel;
  readonly ineligibleEAuthorizationDetailsCopy = Constants.ineligibleEAuthorizationDetailsCopy;
  eAuthSelection: string;
  accountHolderNameAndEmail: { name: string; email: string; } [] = [];
  condensedNameAndEmail: string[] = [];
  eAuthInfo: EAuthInfo;
  destroy$: Subject<boolean> = new Subject<boolean>();
  prefilledText: string = Constants.confirmationPagePrefilledText;
  isAccountHolderSelected: boolean;

  constructor() { }

  ngOnInit(): void {
    this.eAuthInfo$.pipe(takeUntil(this.destroy$)).subscribe(eAuthInfo => {
      this.eAuthSelection = eAuthInfo.isAccountHolderSelected ? 'Yes' : 'No';
      this.eAuthInfo = eAuthInfo;
    })

    this.eAuthCustomers$.pipe(takeUntil(this.destroy$)).subscribe(eAuthCustomers => {
      this.isAccountHolderSelected = this.eAuthInfo.isAccountHolderSelected;
      if (this.eAuthInfo.isAccountHolderSelected) {
        this.eAuthInfo.selectedAccountHolder.forEach((account) => {
          let selectedAccountHolder = eAuthCustomers.find(customer => customer.customerId === account);
          if (selectedAccountHolder) {
            this.accountHolderNameAndEmail.push({'name': `${selectedAccountHolder.firstName} ${selectedAccountHolder.lastName}`, 
                                                 'email': selectedAccountHolder.emailId});
          }
        })
      }
      else {
        this.eAuthSelection = 'No'
      }
    })
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
